// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__IFWY-","container":"styles_container__oYVRg","header":"styles_header__QRFmE","input":"styles_input__Bd+jZ"};